import { render, staticRenderFns } from "./Houseowner.vue?vue&type=template&id=65549fe3&scoped=true&"
import script from "./Houseowner.vue?vue&type=script&lang=js&"
export * from "./Houseowner.vue?vue&type=script&lang=js&"
import style0 from "./Houseowner.vue?vue&type=style&index=0&id=65549fe3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65549fe3",
  null
  
)

export default component.exports